import { TranslocoService } from '@jsverse/transloco';

const I18N_KEY_PATTERN = /^[a-zA-Z][a-zA-Z0-9_]+(\.[a-zA-Z0-9_]+)+$/;

export function isI18nKey(value: string): boolean {
  return I18N_KEY_PATTERN.test(value);
}

export function tryTranslate(translate: TranslocoService, value: string): string {
  if (isI18nKey(value)) {
    const translated = translate.translate(value);
    if (translated !== value) return translated;
  }
  return value;
}
